var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"href":"mailto:feedback@panelalpha.com?subject=PanelAlpha Demo Feedback","x-large":!_vm.$vuetify.breakpoint.mobile,"color":"warning","rounded":""}},[_c('v-icon',[_vm._v("$mail")]),_c('span',{staticClass:"font-weight-600"},[_vm._v("Send Us Your Feedback")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }